/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingUserConfig = {
  loadingUsers: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Retrieving your',
    titleBoldText: 'users list...',
    description: 'This might take few seconds, Please wait !',
  },
  inviteUser: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Inviting user',
    description: 'This might take few seconds, Please wait !',
  },
  usersEmpty: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/resting_black.png',
    titleNormalText: 'Admin Users',
    titleBoldText: 'Not found !',
    description: 'Inviting new users feature to manage this portal',
  },
  suspendUser: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Updating admin user status',
    description: 'This might take few seconds, Please wait !',
  },
  deleteUser: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Deleting admin user',
    description: 'This might take few seconds, Please wait !',
  },
};
